export const EBillingPeriodType = {
  Monthly: 0,

  Quarterly: 1,

  Annual: 2,
}

export type EBillingPeriodType = (typeof EBillingPeriodType)[keyof typeof EBillingPeriodType]
